<div class="page-container">
  <mat-card class="container">
    <h2 class="header-style font">VIEW DEVICE(S) UNDER PLANNED MAINTENANCE</h2>
    <form [formGroup]="pmForm" (ngSubmit)="onSubmit()">
      <div>
        <div class="date-fields">
          <div class="form-field-container">
            <div class="compact-form-field" [ngStyle]="timeCrossed || areInputsDisabled ? {'pointer-events': 'none'} : {}">
              <mat-form-field appearance="outline" class="width">
                <mat-label class="label">PM Start Date ({{pmTimezone}})</mat-label>
                <input matInput readonly [matDatepicker]="picker" formControlName="start_date" class="bgNone"
                  class="form-control" (dateChange)="onStartDatechange($event)"
                  autocomplete="off" [min]="timeZoneData" formControlName="start_date" class="date-input bgNone">
                  <mat-hint>MM-DD-YYYY</mat-hint>
                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-datepicker #picker></mat-datepicker>
            </mat-form-field>
              </div>
            <div class="compact-form-field" [ngStyle]="timeCrossed || areInputsDisabled ? {'pointer-events': 'none'} : {}">
              <input type="time" formControlName="start_time" (change)="onStartTimeChange($event)" [min]="timeData" class="form-control date-input">
            </div>
          </div>
        <div class="form-field-container">
          <div class="compact-form-field">
            <mat-form-field appearance="outline" class="mrAuto" class="width">
              <mat-label class="label">PM End Date ({{pmTimezone}})</mat-label>
              <input matInput readonly [matDatepicker]="picker1"
                autocomplete="off" class="form-control" (dateChange)="onEndDatechange($event)" formControlName="end_date"
                [min]="start" class="form-control date-input" class="bgNone">
              <mat-hint>MM-DD-YYYY</mat-hint>
              <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
              <mat-datepicker #picker1></mat-datepicker>
            </mat-form-field>
            </div>
          <div class="compact-form-field">
            <input type="time" formControlName="end_time" (change)="onEndTimeChange($event)" [min]="selectedStartTime" class="form-control date-input">
          </div>
        </div>
            <i class='fas fa-edit editIcon' [class.edit-disabled]="areInputsDisabled" [class.edit-enabled]="!areInputsDisabled" (click)="toggleEdit()"></i>
        </div>
      </div>

      <table class="table table-borderless align">
        <thead>
          <th class="clr">DEVICE NAME</th>
          <th class="clr">REASON</th>
          <th class="clr">ACTION</th>
        </thead>
        <tbody>
          <tr>
            <td [ngStyle]="isMarkedForDeletion ? {'background-color': 'grey', 'color': 'white'} : {}">{{ pmDetails?.deviceName }}</td>
            <td [ngStyle]="isMarkedForDeletion ? {'background-color': 'grey', 'color': 'white'} : {}" class="width">{{pmDetails?.pdReason}}</td>
            <td [ngStyle]="isMarkedForDeletion ? {'background-color': 'grey', 'color': 'white'} : {}">
              <mat-icon (click)="areInputsDisabled ? null : toggleDeletion()" [class.cursor]="!areInputsDisabled" [class.disabled-icon]="areInputsDisabled">delete</mat-icon>            
            </td>
        </tr>
        </tbody>
      </table>

      <div class="txtctr mgn">
        <div class="newCreated">
          <span class="createUpdte" class="headingSpan bold">CREATED BY</span>
          <div class="new1">
            <span class="createBy">{{pmDetails?.createdBy}}</span><br>
            <span class="createBy">{{pmDetails?.createdAt}}  {{pmTimezone}}</span><br>
          </div>
        </div>

        <div class="newCreated">
          <span class="createUpdte" class="headingSpan bold">UPDATED BY</span>
          <div class="new1">
            <span class="createBy">{{pmDetails?.updatedBy}}</span><br>
            <span class="createBy">{{pmDetails?.updatedAt}}  {{pmTimezone}}</span>
          </div>
        </div>
        <hr>
      </div>


      <div class="action-buttons">
        <button mat-raised-button color="warn" class="back-button back" (click)="back()">BACK</button>
        <button mat-raised-button color="primary" class="submit-button submit" [disabled]="!isSubmitEnabled">UPDATE</button>
      </div>
    </form>
  </mat-card>
</div>